import {defaultTo, get, pipe, toDefaultEmptyString, toKopecks, toNumber} from '@logistics-frontend/utils'

import type {NddClaimProduct, Product} from 'src/shared/types'

function toBarcode(barcode?: string, parcelIndex = 0) {
  return barcode ? `${barcode}-${parcelIndex}` : ''
}

export function fromNddProduct(
  product: Product,
  barcode?: string,
  parcelIndex = 0,
  productIndex = 0,
  isPaymentGoods = false,
): NddClaimProduct {
  const article = get('vendorCode', product)

  return {
    article: article ? article : String(productIndex + 1),
    count: pipe(product, get('count'), defaultTo(1), toNumber),
    name: pipe(product, get('name'), toDefaultEmptyString),
    place_barcode: toBarcode(barcode, parcelIndex),
    barcode: toBarcode(barcode, parcelIndex),
    physical_dims: {
      // @ts-expect-error - нет такого свойства
      weight_gross: 0,
      predefined_volume: 0,
    },
    billing_details: {
      unit_price: isPaymentGoods ? pipe(product, get('price'), toNumber, toKopecks, Math.round) : 0,
      assessed_unit_price: pipe(product, get('estimatedCost'), toNumber, toKopecks, Math.round),
      nds: get('nds', product),
    },
  }
}
